import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function initScroll(): void {
  const scrollEffectEls = document.querySelectorAll<HTMLElement>(".scef");
  if (!scrollEffectEls.length) return;

  scrollEffectEls.forEach((el) => {
    const isThin = el.classList.contains("scef-thin");

    gsap.fromTo(
      el,
      {
        autoAlpha: 0,
        y: 12,
      },
      {
        scrollTrigger: {
          trigger: el,
          start: "top 88%",
          // markers: true,
        },
        duration: 0.3,
        ease: "power1.out",
        y: 0,
        autoAlpha: isThin ? 0.2 : 1,
      },
    );
  });
}
